import { BonusDto } from '@src/app/promotionHub/bonuses/types/BonusDto';
import { getConfig } from '@superbet-group/web.lib.config';
import { ComtradeBonusDto } from '@src/app/promotionHub/bonuses/types/comtradeDto/ComtradeBonusDto';
import BetlerBonusDto from '@src/app/promotionHub/bonuses/types/betlerDto/BetlerBonusDto';
import BonusProvider from '@core/models/bonus/BonusProvider';
import { shellLocalConfig } from '@src/config/shell/localConfig';

export function isBonusAvailableForDomain(bonus: BonusDto) {
    // We need to filter out external free spin bonuses because those are missing a lot of data
    if ((bonus as BetlerBonusDto).external_created_free_spin_award) {
        return false;
    }

    const bonusTypeProperty = getConfig().countrySpecific.user.bonus.bonusProvider === BonusProvider.Comtrade
        ? (bonus as ComtradeBonusDto).BonusType
        : (bonus as BetlerBonusDto).bonus_type;

    return !shellLocalConfig.bonus.excludedBonusTypes?.some((type) => type === bonusTypeProperty);
}
